import React from 'react';
import { Layout, Menu, Avatar, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { useUser } from '../../utils/userContext'; // 添加用户上下文导入
import './index.css';

const { Header: AntHeader } = Layout;
const { Text } = Typography;

const AppHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useUser(); // 使用用户上下文

  const menuItems = [
    { key: '/', label: <Link to="/">首页</Link> },
    { key: '/archive', label: <Link to="/archive">归档</Link> },
    { key: '/write', label: <Link to="/write">写文章</Link> },
    { key: '/about', label: <Link to="/about">我的</Link> },
  ];

  const selectedKey = menuItems.some(item => location.pathname === item.key) 
    ? location.pathname 
    : location.pathname.split('/')[1] || '/';

  const handleGoToLogin = () => {
    navigate('/login'); 
  };

  const handleLogout = () => {
    logout();
    localStorage.removeItem('current_user');
    navigate('/login');
  };

  return (
    <AntHeader className="blog-header" style={{ paddingRight: 20 }}>
      <div className="blog-header-title">
        <Link to="/" className="blog-header-title-link">我的博客</Link>
      </div>
      
      <Menu 
        className="blog-header-menu"
        mode="horizontal" 
        selectedKeys={[selectedKey]}
        items={menuItems.map(item => ({ key: item.key, label: item.label }))}
      />

      <div style={{ display: 'flex', alignItems: 'center' }}>
        {user ? (
          <>
            <Avatar icon={<UserOutlined />} className="user-avatar" />
            <Text className="user-name" style={{ margin: '0 16px' }}>欢迎, {user.username}</Text>
            <Button
              type="text"
              onClick={handleLogout}
              className="logout-link"
              style={{ color: 'rgba(255, 255, 255, 0.85)' }}
            >
              退出
            </Button>
          </>
        ) : (
          <Button
            type="primary"
            onClick={handleGoToLogin}
            style={{ background: '#1890ff', borderColor: '#1890ff' }}
          >
            登录
          </Button>
        )}
      </div>
    </AntHeader>
  );
};

export default AppHeader;